import { rand, randNumber, randParagraph, randPastDate, randSoonDate, randWord } from '@ngneat/falso';
import { BillingParties } from '../base';
import { Quotation } from '../quotations';
import { MockBillingParty } from './billing-party.mock';
import { MockHawb } from './hawb.mock';
import { MockCalculator } from './calculator.mock';
import { optional } from '@library/common/functions';
import { MockReference } from './reference.mock';
import { MockTradeshow } from './tradeshow.mock';
import { MockRisks } from './risks.mock';
import { ModeMilestone } from '../quotations/milestones/mode-milestone';
import { MockStatus } from './status.mock';
import { MockAttachment } from './attachment.mock';
import { IGenericType } from '@library/common/generictype';


export class MockQuotation extends Quotation<any, any> {
    constructor() {
        super({
            quoteType: 'international',
            mode: 'road',
        } as IGenericType);

        this.fwq = MockHawb();

        this.station = new MockBillingParty();

        this.billingParty = rand([ ...BillingParties ]);
        this.shipper = new MockBillingParty();
        this.consignee = new MockBillingParty();
        this.bill_to = new MockBillingParty();

        this.cost = randNumber({ min: 0, max: 10000 }).toFixed( 6 );

        const pastDate = randPastDate();

        this.createdDate = pastDate.getUTCFullYear() + '-' + (pastDate.getUTCMonth() + 1).toString().padStart(2, '0') + '-' + pastDate.getUTCDate().toString().padStart(2, '0'); 
        this.createdTime = pastDate.getUTCHours().toString().padStart(2, '0') + ':' + pastDate.getUTCMinutes().toString().padStart(2, '0') + ':' + pastDate.getUTCSeconds().toString().padStart(2, '0');

        this.serviceLevel = randWord({ length: 2, capitalize: true }).join( ' ' );

        this.calculator = Array.from({ length: randNumber({ max: 10 }) }, _ => new MockCalculator() );

        if ( optional() ) { this.references = Array.from({ length: randNumber({ max: 10 }) }, _ => new MockReference() ); }
        if ( optional() ) { this.tradeshow = [ new MockTradeshow( 'from' ), new MockTradeshow( 'to' ) ]; }

        if ( optional() ) { this.risks = new MockRisks(); }

        this.statuses = Array.from({ length: randNumber({ max: 5 }) }, _ => new MockStatus() );

        if ( optional() ) { this.description = randParagraph(); }
        if ( optional() ) { this.specialInstructions = randParagraph(); }

        if ( optional() ) {
            this.attachments = Array.from({ length: randNumber({ max: 5 }) }, _ => new MockAttachment() );
         }

        this.milestones = new ModeMilestone( this.mode );
        const length = randNumber({ max: Object.keys( this.milestones ).length });
        Object.keys( this.milestones ).map(( key, index ) => {
            if ( index < length && optional() ) {
            this.milestones[key] = randPastDate();
            }
        });

        [
            [ this.pdatefrom, this.ptimefrom ],
            [ this.pdateto, this.ptimeto ],
            [ this.ddatefrom, this.dtimefrom ],
            [ this.ddateto, this.dtimeto ],
            [ this.validToDate, this.validToTime ],
            [ this.createdDate, this.createdTime ],
        ] = randSoonDate({ length: 6, days: 6 }).map( d => d.toISOString().slice( 0, -8 )).sort().map( d => d.split( 'T' ));
    }
}

